import { h } from "preact"
import BerlinLogo from "./BerlinLogo"
import Footer from "./Footer"

export default function Layout({ children }) {
    return (
        <>
            <div className="card layout mt-sm-5 shadow-lg">
                <header>
                    <div className="navbar navbar-expand navbar-dark bg-primary py-1" arial-label="Hauptnavigation">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a href="https://berlin.de" title="Berlin.de" className="nav-link" style={{ fontSize: "1.5rem" }}>
                                    <BerlinLogo />
                                </a>
                            </li>
                        </ul>
                        <div className="flex-grow-1 text-center">
                            <h1 className="text-white m-0">ISBJ Portal</h1>
                        </div>
                    </div>
                </header>
                <main>{children}</main>
            </div>
            <Footer />
        </>
    )
}
